import { Injectable } from '@angular/core';

import { P as Param } from '../tools/ParametrageApplicatif';

@Injectable({
  providedIn: 'root'
})
export class ParametrageApplicatifService {

    private P: (clef: string) => any = Param;

    constructor() { }

    public obtenir(clef: string): any {
        return this.P(clef);
    }
}
